export const EVALUATION_PERIODS = {
  ANUAL: 'anual',
  BIANNUAL: 'semestral',
  QUARTERLY: 'trimestral',
  // Es el valor que envía el API en GET front/courses/{guid}; 'cuatrimestral' solo se acepta como alias (TAN-11212).
  FOUR_MONTHLY: 'quatrimestral',
  BIMONTHLY: 'bimensual',
};

// Defensivo: no se ha visto al API enviar estos valores, pero 'cuatrimestral' es el que usaba este fichero
// y 'annual' el id del periodo anual. Map y no objeto: una clave como 'constructor' no debe resolver (TAN-11212).
const EVALUATION_PERIOD_ALIASES = new Map([
  ['cuatrimestral', EVALUATION_PERIODS.FOUR_MONTHLY],
  ['annual', EVALUATION_PERIODS.ANUAL],
]);

export const EVALUATION_PERIODS_TYPES = [
  {
    name: EVALUATION_PERIODS.QUARTERLY,
    periods: [
      { name: 'Quarter 1', id: 't01' },
      { name: 'Quarter 2', id: 't02' },
      { name: 'Quarter 3', id: 't03' },
    ],
  },
  {
    name: EVALUATION_PERIODS.BIMONTHLY,
    periods: [
      { name: 'Bimester 1', id: 'b01' },
      { name: 'Bimester 2', id: 'b02' },
      { name: 'Bimester 3', id: 'b03' },
      { name: 'Bimester 4', id: 'b04' },
    ],
  },
  {
    name: EVALUATION_PERIODS.BIANNUAL,
    periods: [
      { name: 'Semester 1', id: 's01' },
      { name: 'Semester 2', id: 's02' },
    ],
  },
  // q01-q02 pendiente de confirmar contra el catálogo v3/sys/evaluation_periods: si los items traen otros
  // qNN, buildEvaluationPeriods (DialogOrganizeCourse) les da su propia sección (TAN-11212).
  {
    name: EVALUATION_PERIODS.FOUR_MONTHLY,
    periods: [
      { name: 'Quadrimester 1', id: 'q01' },
      { name: 'Quadrimester 2', id: 'q02' },
    ],
  },
  { name: EVALUATION_PERIODS.ANUAL, periods: [{ name: 'School year', id: 'annual' }] },
];

/**
 * Valor de `course.evaluation_period` sin espacios, en minúsculas y con los alias resueltos; '' si no es texto.
 * @param {unknown} value
 * @returns {string}
 */
export function normalizeEvaluationPeriod(value) {
  if (typeof value !== 'string') return '';
  const normalized = value.trim().toLowerCase();
  return EVALUATION_PERIOD_ALIASES.get(normalized) ?? normalized;
}

/**
 * Entrada de `EVALUATION_PERIODS_TYPES` para `course.evaluation_period`; undefined si está vacío o no se conoce.
 * @param {unknown} value
 */
export function findEvaluationPeriodType(value) {
  const normalized = normalizeEvaluationPeriod(value);
  return normalized ? EVALUATION_PERIODS_TYPES.find((type) => type.name === normalized) : undefined;
}
